/* @flow */
import React from 'react';

import Button from 'components/Button.jsx';
import Chat from 'entities/Chat';
import ChatActions from 'chat/actions/ChatActions';
import CurrentUser from 'auth/CurrentUser';
import Glyph from 'components/Glyph.jsx';
import SetUserEmailModal from 'settings/components/SetUserEmailModal.jsx';
import { mountModal } from 'lib/modal';

class EmailChatHistoryButton extends React.Component {
  static propTypes = {
    chat: React.PropTypes.instanceOf(Chat).isRequired,
    buttonClassName: React.PropTypes.string,
  };

  emailTranscript = (): void => {
    if (!CurrentUser.hasEmail()) {
      mountModal(<SetUserEmailModal onSave={this.emailTranscript} />, this);
      return;
    }

    ChatActions.emailTranscript(this.props.chat.id);
  };

  renderEmailChatHistory() {
    return (
      <Button
        className={this.props.buttonClassName}
        level="text"
        weight="semibold"
        onClick={this.emailTranscript}>
        <Glyph name="email-transcript" size="large" />
        <span>Email message history</span>
      </Button>
    );
  }

  render() {
    return (
      <div>
        {this.renderEmailChatHistory()}
      </div>
    );
  }
}

export default EmailChatHistoryButton;



// WEBPACK FOOTER //
// ./src/chat/components/EmailChatHistoryButton.jsx